export default [
    {
        id: "01",
        url: "01-klima-und-umwelt",
        title: "Klima-, Umwelt und Energie" 
    },
    {
        id: "02",
        title: "Verkehrs- und Stadtplanung",
        url: "02-verkehr-und-stadtplanung"
    },
    {
        id: "03",
        title: "Soziale Gerechtigkeit, Familie, Bildung",
        url: "03-soziale-gerechtigkeit-familie-bildung"
    },
    {
        id: "04",
        title: "Wirtschaft, Bauen, Wohnen und Gesundheit",
        url: "04-wirtschaft-bauen-wohnen-gesundheit"
    },
    {
        id: "05",
        title: "städtische Finanzen",
        url: "05-finanzen"
    },
    {
        id: "06",
        title: "Weiden - Stadt der Vielfalt, Kunst und Kultur",
        url: "06-stadt-der-vielfalt"
    }
]
